<template>
  <ContentTemplate title="Themes">
    <div class="row">
      <div class="col-4">
        <ThemeCardWidget label="Light" icon="Sun" for-name="sun"
                         :is-selected="selectedTheme === 'LIGHT'"
                         @onSelected="lightThemeSelected()">
          bright and clean
        </ThemeCardWidget>
      </div>
      <div class="col-4">
        <ThemeCardWidget label="Dark (Beta)" icon="MoonStar" :is-dark="true"
                         :is-selected="selectedTheme === 'DARK'" for-name="dark"
                         @onSelected="darkThemeSelected()"
        >
          low light and more visibility
        </ThemeCardWidget>
      </div>
    </div>
  </ContentTemplate>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {ContentTemplate, ThemeCardWidget,} from '@shared/components';
import {type UIPreferencesNs} from "@shared/types";
import {mapStores} from "pinia";
import {useUserStore} from "@shared/stores/user.store";
import {useGeneralStore} from "@shared/stores/general.store";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'ThemesView',
  components: {
    ContentTemplate,
    ThemeCardWidget,
  },
  computed: {
    ...mapStores(useUserStore, useGeneralStore),
    selectedTheme(): 'DARK' | 'LIGHT' {
      return this.userStore.getSelectedTheme
    }
  },

  methods: {
    lightThemeSelected(): void {
      this.updateSelectedTheme('LIGHT');
    },
     darkThemeSelected(): void {
       this.updateSelectedTheme('DARK');
     },
    updateSelectedTheme(selectedTheme: string): void {
      const payload = {
        selectedTheme,
      } as UIPreferencesNs.UIPreferences;

      this.userStore.setSelectedTheme(payload).then(() => {
        toast.success('Theme updated');
      })
    },
  },
});
</script>
